import MembershipOpenInvoiceListModelBase from '../_generated/modelBases/membership-open-invoice-list-model-base';

export default class MembershipOpenInvoiceListModel extends MembershipOpenInvoiceListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
